<template>
  <div>
    <date-picker :value-type="!range ? 'date' : 'format'" :name="name" :format="format" :clearable="!range" :placeholder="placeholder" :range="range" :autoApply="true" @change="change" v-model="date" class="sweet-calendar" input-class="form-control" :type="type">
      <div slot="icon-calendar">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 19C12.1978 19 12.3911 18.9414 12.5556 18.8315C12.72 18.7216 12.8482 18.5654 12.9239 18.3827C12.9996 18.2 13.0194 17.9989 12.9808 17.8049C12.9422 17.6109 12.847 17.4327 12.7071 17.2929C12.5673 17.153 12.3891 17.0578 12.1951 17.0192C12.0011 16.9806 11.8 17.0004 11.6173 17.0761C11.4346 17.1518 11.2784 17.28 11.1685 17.4444C11.0586 17.6089 11 17.8022 11 18C11 18.2652 11.1054 18.5196 11.2929 18.7071C11.4804 18.8946 11.7348 19 12 19ZM17 19C17.1978 19 17.3911 18.9414 17.5556 18.8315C17.72 18.7216 17.8482 18.5654 17.9239 18.3827C17.9996 18.2 18.0194 17.9989 17.9808 17.8049C17.9422 17.6109 17.847 17.4327 17.7071 17.2929C17.5673 17.153 17.3891 17.0578 17.1951 17.0192C17.0011 16.9806 16.8 17.0004 16.6173 17.0761C16.4346 17.1518 16.2784 17.28 16.1685 17.4444C16.0586 17.6089 16 17.8022 16 18C16 18.2652 16.1054 18.5196 16.2929 18.7071C16.4804 18.8946 16.7348 19 17 19ZM17 15C17.1978 15 17.3911 14.9414 17.5556 14.8315C17.72 14.7216 17.8482 14.5654 17.9239 14.3827C17.9996 14.2 18.0194 13.9989 17.9808 13.8049C17.9422 13.6109 17.847 13.4327 17.7071 13.2929C17.5673 13.153 17.3891 13.0578 17.1951 13.0192C17.0011 12.9806 16.8 13.0004 16.6173 13.0761C16.4346 13.1518 16.2784 13.28 16.1685 13.4444C16.0586 13.6089 16 13.8022 16 14C16 14.2652 16.1054 14.5196 16.2929 14.7071C16.4804 14.8946 16.7348 15 17 15ZM12 15C12.1978 15 12.3911 14.9414 12.5556 14.8315C12.72 14.7216 12.8482 14.5654 12.9239 14.3827C12.9996 14.2 13.0194 13.9989 12.9808 13.8049C12.9422 13.6109 12.847 13.4327 12.7071 13.2929C12.5673 13.153 12.3891 13.0578 12.1951 13.0192C12.0011 12.9806 11.8 13.0004 11.6173 13.0761C11.4346 13.1518 11.2784 13.28 11.1685 13.4444C11.0586 13.6089 11 13.8022 11 14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15ZM19 3H18V2C18 1.73478 17.8946 1.48043 17.7071 1.29289C17.5196 1.10536 17.2652 1 17 1C16.7348 1 16.4804 1.10536 16.2929 1.29289C16.1054 1.48043 16 1.73478 16 2V3H8V2C8 1.73478 7.89464 1.48043 7.70711 1.29289C7.51957 1.10536 7.26522 1 7 1C6.73478 1 6.48043 1.10536 6.29289 1.29289C6.10536 1.48043 6 1.73478 6 2V3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V20C2 20.7956 2.31607 21.5587 2.87868 22.1213C3.44129 22.6839 4.20435 23 5 23H19C19.7956 23 20.5587 22.6839 21.1213 22.1213C21.6839 21.5587 22 20.7956 22 20V6C22 5.20435 21.6839 4.44129 21.1213 3.87868C20.5587 3.31607 19.7956 3 19 3ZM20 20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8946 19.2652 21 19 21H5C4.73478 21 4.48043 20.8946 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H20V20ZM20 9H4V6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5H6V6C6 6.26522 6.10536 6.51957 6.29289 6.70711C6.48043 6.89464 6.73478 7 7 7C7.26522 7 7.51957 6.89464 7.70711 6.70711C7.89464 6.51957 8 6.26522 8 6V5H16V6C16 6.26522 16.1054 6.51957 16.2929 6.70711C16.4804 6.89464 16.7348 7 17 7C17.2652 7 17.5196 6.89464 17.7071 6.70711C17.8946 6.51957 18 6.26522 18 6V5H19C19.2652 5 19.5196 5.10536 19.7071 5.29289C19.8946 5.48043 20 5.73478 20 6V9ZM7 15C7.19778 15 7.39112 14.9414 7.55557 14.8315C7.72002 14.7216 7.84819 14.5654 7.92388 14.3827C7.99957 14.2 8.01937 13.9989 7.98079 13.8049C7.9422 13.6109 7.84696 13.4327 7.70711 13.2929C7.56725 13.153 7.38907 13.0578 7.19509 13.0192C7.00111 12.9806 6.80004 13.0004 6.61732 13.0761C6.43459 13.1518 6.27841 13.28 6.16853 13.4444C6.05865 13.6089 6 13.8022 6 14C6 14.2652 6.10536 14.5196 6.29289 14.7071C6.48043 14.8946 6.73478 15 7 15ZM7 19C7.19778 19 7.39112 18.9414 7.55557 18.8315C7.72002 18.7216 7.84819 18.5654 7.92388 18.3827C7.99957 18.2 8.01937 17.9989 7.98079 17.8049C7.9422 17.6109 7.84696 17.4327 7.70711 17.2929C7.56725 17.153 7.38907 17.0578 7.19509 17.0192C7.00111 16.9806 6.80004 17.0004 6.61732 17.0761C6.43459 17.1518 6.27841 17.28 6.16853 17.4444C6.05865 17.6089 6 17.8022 6 18C6 18.2652 6.10536 18.5196 6.29289 18.7071C6.48043 18.8946 6.73478 19 7 19Z" fill="#BDBDBD"/>
        </svg>
      </div>
    </date-picker>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
export default {
  name: "SweetDatePicker",
  inject: ['$validator'],
  components: {
    DatePicker
  },
  data() {
    return {
      date: null
    }
  },
  mounted() {
    this.date = typeof this.value === 'string' ? new Date(this.value) : this.value
  },
  methods: {
    change(val) {
      if(val instanceof Date) {
        // WTF?!
        this.$emit('input', new Date(val.getTime() - (val.getTimezoneOffset() * 60000)).toISOString())
      } else {
        this.$emit('input', val)
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'datetime'
    },
    name: {
      type: String,
      default: 'date'
    },
    placeholder: {
      type: String,
      default: 'Выберите дату'
    },
    value: {
      type: [String, Array, Date],
      required: false
    },
    open: {
      type: Boolean,
      required: false
    },
    range: {
      type: Boolean,
      default: true
    },
    format: {
      type: String,
      default() {
        return this.type === 'datetime' ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY'
      }
    }
  },
  watch: {
    value: {
      handler: function(val) {
        this.date = typeof val === 'string' ? new Date(val) : val
      },
      deep: true,
      immediate: true
    }
  },
}
</script>

<style lang="scss">
.sweet-calendar {
  width: 100%;
  .mx-icon-calendar, .mx-icon-clear {
    left: 8px;
    font-size: 2rem;
  }
  .form-control {
    padding: 1.2rem 1.4rem 1.2rem 3.4rem;
  }
}
.mx-calendar {
  &.mx-calendar-panel-date {
    width: 38.4rem;
  }
  font-size: 1.6rem;
  line-height: 1.6rem;
  color: #002E5E;
  .cell, th {
    height: 6rem;
    font-size: 2rem;
  }
  &-content {
    height: auto;
  }
  &-header {
    position: relative;
    height: 3.2rem;
    line-height: 3.4rem;
    .mx-calendar-header-label {
      .mx-btn-current-month,
      .mx-btn-current-year {
        font-size: 2.4rem;
        line-height: 2.4rem;
        font-weight: 700;
        text-align: left;
        justify-content: flex-start;
        align-items: center;
        color: #333!important;
        text-transform: capitalize;
      }
      position: absolute;
      left: 0;
      top: 0.6rem;
    }
    .mx-btn-icon-double-left,
    .mx-btn-icon-double-right {
      display: none;
    }
    .mx-btn-icon-left {
      position: absolute!important;
      right: 7.2rem;
    }
    .mx-btn-icon-right {
      transform: translate(-50%, -50%) rotate(180deg);
      position: absolute!important;
      right: -1.4rem;
      top: 1.6rem;
      @media (max-width: 768px) {
        top: 2.3rem;
      }
    }
    .mx-btn-icon-left,
    .mx-btn-icon-right {
      width: 3.2rem;
      height: 3.2rem;
      border-radius: 50%;
      border: 2px solid #002E5E !important;
      margin: 0;
      background-color: transparent;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none !important;
      transition: 0.3s linear;
      position: relative;
      text-indent: -10000px;
      color: transparent;

      &:hover {
        background: #002E5E !important;

        &:before {
          background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.92 11.6202C17.8724 11.4974 17.801 11.3853 17.71 11.2902L12.71 6.29019C12.6168 6.19695 12.5061 6.12299 12.3842 6.07253C12.2624 6.02207 12.1319 5.99609 12 5.99609C11.7337 5.99609 11.4783 6.10188 11.29 6.29019C11.1968 6.38342 11.1228 6.49411 11.0723 6.61594C11.0219 6.73776 10.9959 6.86833 10.9959 7.00019C10.9959 7.26649 11.1017 7.52188 11.29 7.71019L14.59 11.0002H7C6.73478 11.0002 6.48043 11.1055 6.29289 11.2931C6.10536 11.4806 6 11.735 6 12.0002C6 12.2654 6.10536 12.5198 6.29289 12.7073C6.48043 12.8948 6.73478 13.0002 7 13.0002H14.59L11.29 16.2902C11.1963 16.3831 11.1219 16.4937 11.0711 16.6156C11.0203 16.7375 10.9942 16.8682 10.9942 17.0002C10.9942 17.1322 11.0203 17.2629 11.0711 17.3848C11.1219 17.5066 11.1963 17.6172 11.29 17.7102C11.383 17.8039 11.4936 17.8783 11.6154 17.9291C11.7373 17.9798 11.868 18.006 12 18.006C12.132 18.006 12.2627 17.9798 12.3846 17.9291C12.5064 17.8783 12.617 17.8039 12.71 17.7102L17.71 12.7102C17.801 12.6151 17.8724 12.5029 17.92 12.3802C18.02 12.1367 18.02 11.8636 17.92 11.6202Z' fill='%23ffffff'/%3E%3C/svg%3E");;
        }
      }

      @media (max-width: 768px){
        border-width: 2px !important;
        width: 24px;
        height: 24px;
        zoom: 0.7;
      }

      &:before {
        width: 2.4rem;
        height: 2.4rem;
        display: block;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.92 11.6202C17.8724 11.4974 17.801 11.3853 17.71 11.2902L12.71 6.29019C12.6168 6.19695 12.5061 6.12299 12.3842 6.07253C12.2624 6.02207 12.1319 5.99609 12 5.99609C11.7337 5.99609 11.4783 6.10188 11.29 6.29019C11.1968 6.38342 11.1228 6.49411 11.0723 6.61594C11.0219 6.73776 10.9959 6.86833 10.9959 7.00019C10.9959 7.26649 11.1017 7.52188 11.29 7.71019L14.59 11.0002H7C6.73478 11.0002 6.48043 11.1055 6.29289 11.2931C6.10536 11.4806 6 11.735 6 12.0002C6 12.2654 6.10536 12.5198 6.29289 12.7073C6.48043 12.8948 6.73478 13.0002 7 13.0002H14.59L11.29 16.2902C11.1963 16.3831 11.1219 16.4937 11.0711 16.6156C11.0203 16.7375 10.9942 16.8682 10.9942 17.0002C10.9942 17.1322 11.0203 17.2629 11.0711 17.3848C11.1219 17.5066 11.1963 17.6172 11.29 17.7102C11.383 17.8039 11.4936 17.8783 11.6154 17.9291C11.7373 17.9798 11.868 18.006 12 18.006C12.132 18.006 12.2627 17.9798 12.3846 17.9291C12.5064 17.8783 12.617 17.8039 12.71 17.7102L17.71 12.7102C17.801 12.6151 17.8724 12.5029 17.92 12.3802C18.02 12.1367 18.02 11.8636 17.92 11.6202Z' fill='%23002E5E'/%3E%3C/svg%3E");
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(180deg);

        @media (max-width: 767px){
          background-size: 16px auto;
        }
      }
    }
  }
  &-panel-year {
    .mx-btn-icon-double-left,
    .mx-btn-icon-double-right {
      display: block;
    }
    .mx-calendar-header-label {
      position: relative;
    }
  }
}
.mx-time-header {
  .mx-btn {
    font-size: 2rem!important;
  }
}
.mx-time-content {
  height: 40rem;
  .mx-time-item {
    font-size: 2rem;
  }
}
</style>